import { _getAiObjectsRequest } from './aiObjectsRequests'

const formStatisticsPageRequests = {
  getFormByIdRequest: (formId) => ({
    url: `api/forms/${formId}`,
    method: 'get',
  }),
  updateFormControlProcessingRequest: (data) => ({
    url: `api/forms/formcontrols/processing`,
    method: 'put',
    data,
  }),
  getAiClassesForFormInfoRequest: _getAiObjectsRequest,
}

export default formStatisticsPageRequests
